import { render } from "./MfittBookingVacantSeatsError.vue?vue&type=template&id=e6c995ba"
import script from "./MfittBookingVacantSeatsError.vue?vue&type=script&lang=js"
export * from "./MfittBookingVacantSeatsError.vue?vue&type=script&lang=js"
script.render = render

export default script